import { ApiFetchType } from '@/server/api-fetch';
import { MarketType } from './page';

type AcfImage =
    | {
          url: string;
          alt: string;
          width: number;
          height: number;
      }
    | false;

type AcfLink =
    | {
          title: string;
          url: string;
          target: string;
      }
    | false;

export type HeaderSettingsApiResponse = {
    login_choices: {
        login_link_text: string;
        login_link_text_mobile?: string;
        login_link_url?: {
            title: string;
            url: string;
            target: string;
        };
    }[];
    market_logos?: Record<Exclude<MarketType, 'cluster'>, AcfImage>;
    market_logo_links?: Record<Exclude<MarketType, 'cluster'>, AcfLink>;
};

export const HEADER_SETTINGS_QUERY_KEY = 'header-settings';

export const getHeaderSettings = (context: ApiFetchType) => (context.fetch ? context.fetch<HeaderSettingsApiResponse>('api/general/header') : null);
